import { Box, Typography, Divider, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

interface FormSectionProps {
    title: string;
    children: ReactNode;
    showDivider?: boolean;
    sx?: SxProps<Theme>;
}

const FormSection = ({
    title,
    children,
    showDivider = false,
    sx,
}: FormSectionProps) => (
    <Box sx={sx}>
        {showDivider && <Divider sx={{ my: 2 }} />}
        <Typography variant="subtitle1" sx={{ mt: 4, mb: 1, fontWeight: 600 }}>
            {title}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {children}
        </Box>
    </Box>
);

export default FormSection;
